/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const t={type:String,json:{read:{source:"token"},write:{target:"token"}}};export{t as apiKey};
